import Vue from 'vue';

import FakeYoutube from './Components/FakeYoutube.vue';
Vue.component('fake-youtube', FakeYoutube);
